// extracted by mini-css-extract-plugin
export var audioPlayer = "_qr-0";